import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';

const MandatoryMsg = (props) => {

    const useStyles = makeStyles(({
        mandatoryMsgDiv:{
          paddingTop : "4px"
        },
        mandatoryMsgSpanLTR:{
            textAlign: 'left',
            letterSpacing: '0px',
            color: '#c32525',
            opacity: 1,
            fontSize:'10px',
            // lineHeight:'23px',
            lineHeight:1,
        },
        mandatoryMsgSpanRTL:{
            textAlign: 'right',
            letterSpacing: '0px',
            color: '#c32525',
            opacity: 1,
            fontSize:'10px',
            // lineHeight:'23px',
            lineHeight:1,
        },
    }));

    var msgClasses = useStyles();
    const { t } = useTranslation();

    const {
        id,
        mandatoryMsg,
    } = props;

    const lang = window?.psh_configs?.selectedLanguage;
    let dir = 'ltr';
    if(lang?.startsWith('ar')){
        dir = 'rtl';
    } else {
        dir = 'ltr';
    }
    if (props.mandatoryMsg){
      return (
        <div className={msgClasses.mandatoryMsgDiv}>
          <span id="mandatorymsgid1"
            className={
              dir === "ltr"
                ? msgClasses.mandatoryMsgSpanLTR
                : msgClasses.mandatoryMsgSpanRTL
            }
          >
            {mandatoryMsg === "This field is required." ? t(`translation:${mandatoryMsg}`) : mandatoryMsg}
          </span>
        </div>
      );
    } else {
    }
}

export default MandatoryMsg